import React, { Suspense, useState } from 'react';
import { Modal, Button, Steps, Spin } from 'antd';
import GrtLoding from '../GrtLoading/GRTLoading';
import { useEffect } from 'react';
import { useSearchParams, useLocation, useNavigate, useParams } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import { tipObj } from '@/utils/realName';
import { IsInValidLink } from '@/utils/utils';
import ImproveModal from '@/components/ImproveInformation/improveModal';
import ForceNoticeModal from '../ForceNotice/forceNoticeModal';
import QuestionModal from '@/page/Project/Home/questionModal';
import { observer, inject } from 'mobx-react';
import { handleRealDetail } from '@/api/FaceAndRealName';
import Toast from '@/components/Toast';
import style from './style.m.less';

const grey_dot = require('@/assets/images/auth/dot_grey.png');

const needTestInValidLinks = ['exam', 'practise', 'researchResult'],
    Auth = (props) => {
        const location = useLocation();
        const navigate = useNavigate();
        const params = useParams();
        const linkTo = (path) => {
            navigate(path);
        };
        const [searchParams, setSearchParams] = useSearchParams(),
            { face } = props.store,
            [routerParams, setRouterParams] = useState<any>({}),
            [loading, setLoading] = useState<any>(false),
            [routerSetting, setRouterSetting] = useState<any>({}),
            init = async (params) => {
                if (
                    needTestInValidLinks.includes(props.realNameType) &&
                    IsInValidLink({
                        setSearchParams,
                        searchParams
                    })
                ) {
                    return false;
                }
                setLoading(true);
                await face.getRealPrompt({ business_id: params?.business_id, template_id: params?.template_id });
                setLoading(false);
            };
        useEffect(() => {
            if (props.needJudgeRealName && props.realNameType) {
                let tipObjData = tipObj({ ...props, params: params, searchParams: searchParams });
                if (tipObjData) {
                    setRouterParams(tipObjData.params);
                    setRouterSetting(tipObjData);
                    init(tipObjData.params);
                }
            }
        }, [props.path]);

        if (props.resourcePageName === '404' && props.resource_path === '*') {
            return <Navigate to="/404" />;
        }

        const function_type = {
            1: {
                lable: '实名认证',
                icon_unfinished: require('@/assets/images/auth/1_grey.png'),
                icon_active: require('@/assets/images/auth/1_active.png'),
                dot_active: require('@/assets/images/auth/1_dot_active.png'),
                dot_finished: require('@/assets/images/auth/1_dot_finished.png')
            },
            2: {
                lable: '完善信息',
                icon_unfinished: require('@/assets/images/auth/2_grey.png'),
                icon_active: require('@/assets/images/auth/2_active.png'),
                dot_active: require('@/assets/images/auth/2_dot_active.png'),
                dot_finished: require('@/assets/images/auth/2_dot_finished.png')
            },
            3: {
                lable: '通知公告',
                icon_unfinished: require('@/assets/images/auth/3_grey.png'),
                icon_active: require('@/assets/images/auth/3_active.png'),
                dot_active: require('@/assets/images/auth/3_dot_active.png'),
                dot_finished: require('@/assets/images/auth/3_dot_finished.png')
            },
            4: {
                lable: '问卷调查',
                icon_unfinished: require('@/assets/images/auth/4_grey.png'),
                icon_active: require('@/assets/images/auth/4_active.png'),
                dot_active: require('@/assets/images/auth/4_dot_active.png'),
                dot_finished: require('@/assets/images/auth/4_dot_finished.png')
            }
        };

        const refreshStaus = async () => {
            setLoading(true);
            let res = await handleRealDetail();
            if (res.code === '00000' && res.data?.verify_state === 1) {
                Toast.info('认证成功');
                await face.getRealPrompt({ business_id: routerParams?.business_id, template_id: routerParams?.template_id });
                setLoading(false);
            } else {
                Toast.error('您还未完成实名认证');
                await face.getRealPrompt({ business_id: routerParams?.business_id, template_id: routerParams?.template_id });
                setLoading(false);
            }
        };

        const nextStep = async () => {
            setLoading(true);
            await face.getRealPrompt({ business_id: routerParams?.business_id, template_id: routerParams?.template_id });
            setLoading(false);
        };


        useEffect(() => {
            if (face.currentPromptbox?.function_status === 1 && props.needJudgeRealName) {
                setTimeout(() => {
                    let dom: HTMLElement | null = document.querySelector('.grt-modal-custom-wrap');
                    if (dom) {
                        dom.focus();
                        dom.onkeydown = (e) => {
                            // 确保target是HTMLElement类型再访问tagName属性
                            const target = e.target as HTMLElement;
                            // 允许常见表单元素的键盘事件通过
                            const allowedTags = ['input', 'select', 'textarea', 'button'];
                            if (!allowedTags.includes(target.tagName.toLowerCase())) {
                                e.stopPropagation();
                                e.preventDefault();
                                return false;
                            }
                        };
                    }
                }, 500);
            }
        }, [face.currentPromptbox?.function_status]);

        return (
            <>
                {face.currentPromptbox?.function_status === 1 && props.needJudgeRealName ? (
                    <Modal
                        width={960}
                        open={true}
                        closable={false}
                        footer={null}
                        onCancel={() => {
                            props.close(false);
                        }}
                        wrapClassName={'grt-modal-custom-wrap'}
                        destroyOnClose={true}
                        maskClosable={false}
                    >
                        <Spin spinning={loading}>
                            <div className={`${style.authModal}`}>
                                <div className={style.authModalTitle}>
                                    <img
                                        style={{ width: '20px', height: '20px', marginRight: '10px' }}
                                        src={require('@/assets/images/auth/tongzhi.png')}
                                        alt=""
                                    />
                                    <span style={{ lineHeight: '20px' }}>根据组织要求，请完成以下事项后进行学习</span>
                                </div>
                                <div
                                    style={{
                                        width:
                                            face.promptboxData.length === 1
                                                ? '94px'
                                                : face.promptboxData.length === 2
                                                ? '260px'
                                                : face.promptboxData.length === 3
                                                ? '460px'
                                                : '660px',
                                        margin: '0 auto'
                                    }}
                                >
                                    <Steps
                                        current={face.currentPromptbox?.function_type}
                                        labelPlacement="vertical"
                                        items={face.promptboxData?.map((item) => ({
                                            title: (
                                                <div
                                                    style={{
                                                        position: 'relative',
                                                        fontSize: '16px',
                                                        marginLeft: '-15px',
                                                        width: '64px',
                                                        fontWeight: '500',
                                                        color:
                                                            item.function_status === 2 || item.function_type === face.currentPromptbox?.function_type
                                                                ? 'rgba(0,0,0,0.85)'
                                                                : 'rgba(0,0,0,0.65)'
                                                    }}
                                                >
                                                    {function_type[item.function_type].lable}
                                                    <span style={{ position: 'absolute', right: '-38px' }}>
                                                        {item.number > 99 ? '（99+）' : item.number > 1 ? `（${item.number}）` : ''}
                                                    </span>
                                                </div>
                                            ),
                                            icon: (
                                                <img
                                                    style={{ width: '14px', height: '14px' }}
                                                    src={
                                                        item.function_status === 2
                                                            ? function_type[item.function_type].dot_finished
                                                            : item.function_type === face.currentPromptbox?.function_type
                                                            ? function_type[item.function_type].dot_active
                                                            : grey_dot
                                                    }
                                                />
                                            ),
                                            subTitle: (
                                                <div
                                                    style={{
                                                        position: 'absolute',
                                                        top: '-84px',
                                                        left: '28%',
                                                        transform: 'translateX(-50%)'
                                                    }}
                                                >
                                                    <img
                                                        style={{ width: '70px' }}
                                                        src={
                                                            item.function_status === 2 || item.function_type === face.currentPromptbox?.function_type
                                                                ? function_type[item.function_type].icon_active
                                                                : function_type[item.function_type].icon_unfinished
                                                        }
                                                        alt=""
                                                    />
                                                </div>
                                            )
                                        }))}
                                    />
                                </div>
                                <div>
                                    {face.currentPromptbox?.function_type === 1 ? (
                                        <>
                                            <div
                                                className={style.authModalContent}
                                                style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                                            >
                                                <div>
                                                    <img
                                                        style={{ width: '300px', height: '300px' }}
                                                        src={require('@/assets/images/auth/face.png')}
                                                        alt=""
                                                    />
                                                </div>
                                                <div
                                                    style={{
                                                        width: '304px',
                                                        height: '158px',
                                                        backgroundColor: '#fff',
                                                        marginLeft: '30px',
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        justifyContent: 'center',
                                                        alignItems: 'center'
                                                    }}
                                                >
                                                    <div
                                                        style={{ fontSize: '14px', fontWeight: 500, color: 'rgba(0,0,0,0.85)', marginBottom: '16px' }}
                                                    >
                                                        请先前往App端完成实名认证
                                                    </div>
                                                    <div style={{ fontSize: '14px', color: 'rgba(0,0,0,0.85)' }}>
                                                        我已完成认证
                                                        <span
                                                            style={{ color: '#3B70FF', cursor: 'pointer', marginLeft: '8px' }}
                                                            onClick={refreshStaus}
                                                        >
                                                            刷新
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className={style.authModalButton}>
                                                <Button
                                                    onClick={() => {
                                                        window.modalInfo?.destroy();
                                                        navigate(routerSetting?.path || '/');
                                                    }}
                                                    type="primary"
                                                    style={{ width: '262px' }}
                                                >
                                                    返回列表
                                                </Button>
                                            </div>
                                        </>
                                    ) : face.currentPromptbox?.function_type === 2 ? (
                                        <ImproveModal
                                            business_id={routerParams?.business_id}
                                            template_id={routerParams?.template_id}
                                            nextStep={nextStep}
                                            type="add"
                                        />
                                    ) : face.currentPromptbox?.function_type === 3 ? (
                                        <ForceNoticeModal business_id={routerParams?.business_id} template_id={routerParams?.template_id} />
                                    ) : face.currentPromptbox?.function_type === 4 ? (
                                        <QuestionModal business_id={routerParams?.business_id} template_id={routerParams?.template_id} />
                                    ) : null}
                                </div>
                            </div>
                        </Spin>
                    </Modal>
                ) : null}

                <Suspense fallback={<GrtLoding />}>
                    {
                        <props.element
                            {...props}
                            searchParams={searchParams}
                            setSearchParams={setSearchParams}
                            navigate={linkTo}
                            location={location}
                            params={params}
                        />
                    }
                </Suspense>
            </>
        );
    };

export default inject('store')(observer(Auth));
